import { render, staticRenderFns } from "./DesenvolvimentoInfantil.vue?vue&type=template&id=6e013a74"
import script from "./DesenvolvimentoInfantil.vue?vue&type=script&lang=js"
export * from "./DesenvolvimentoInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports